import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import Form, { RequiredValidator, Actions, Wysiwyg, Assets, SwitchGroup } from '../../Components/Form';
import Alert from '../../Components/Alert';

const Content = () => {
    const {website, updateContent} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Website content" />
        <Page>
            {website && <Inner {...{website, updateContent}} />}
        </Page>
    </>
}

const Inner = ({website, updateContent}) => {
    if (website.type !== 'getsoapy') {
        return <Alert theme="error" title="Not available" message="This feature is only available for getSoapy websites." />
    }

    return <Form data={website} onSubmit={updateContent}>
        <Wysiwyg name="aboutText"
            label="Homepage text"
            features={['basicFormatting', 'moreFormatting', 'advancedFormatting']}
            validators={[RequiredValidator]}
        />

        <Assets name="aboutAssets"
            label="Homepage images"
            tags={[{name: 'Website', value: 'About'}]}
            dimensions={['500x']}
            showPrevious
        />

        <SwitchGroup name="footerOptions"
            label="Footer options"
            switches={[
                {name: 'showAddress', label: 'Show address'},
                {name: 'showSocials', label: 'Show social media links'},
                {name: 'showPhoneNumber', label: 'Show phone number'},
                {name: 'showEmail', label: 'Show email address'},
                {name: 'showPoweredBySoapy', label: 'Show "Powered By getSoapy"'},
            ]}
        />

        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default Content;
